
import { reduce } from 'vessel/utils'

export default {
  inheritAttrs: false,
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  vessel: {
    text: {
      fontSize: 'md',
      color: 'black'
    },
    label: {
      $extend: 'text',
      fontWeight: 'semibold'
    },
    value: {
      $extend: 'text',
      fontWeight: 'light'
    }
  },
  computed: {
    items() {
      return reduce(this.product.properties, (result, property) => {
        const { name, value, multiple, displayAs } = property

        let item = result.find(prop => prop.name == name)

        if (!item) {
          item = { name, displayAs, values: [] }
          result.push(item)
        }

        if (multiple) {
          item.values.push(value)
        } else {
          item.values = [value]
        }
      })
    }
  }
}
